import vizzleAxios from './service';

export const checkPdfLink = async (pdfLinkKey) => {
  const url = `${process.env.REACT_APP_MEDIA_API_URL}/media/link/s3?prefix=${pdfLinkKey}`;
  const result = await vizzleAxios.get(url);
  return result;
};
